import React from 'react';
import PropTypes from 'prop-types';

import { ActionBtn, AlertDialog, toast } from '@meronex/components';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import IShield from '@meronex/icons/fi/FiShield';
import TopHeader from '../../../views/components/TopHeader';
import RoleForm from './RoleForm';
import { rolesMng } from '../api/rolesMng';

function EditRoleDialog(props) {

  const { open, onClose, onEdit } = props;

  const [loading, setLoading] = React.useState(false);
  const [role, setRole] = React.useState(props.role || {});
  const [openAlertOnEdit, setOpenAlertOnEdit] = React.useState(false);

  const _onClose = () => {
    onClose();
  };

  const _onSave = () => {
    setOpenAlertOnEdit(true);
  };
  const editRole = async () => {
    setLoading(true);

    try {
      await rolesMng.updateRole(role);
      onEdit();
      toast.success('Role updated successfully', {
        autoClose: 1750,
      });
    } catch (e) {
      toast.error('Ops, something went wrong');
      console.error(e);
    } finally {
      setLoading(false);
    }
  };
  if (!role || !open) {
    return null;
  }
  return (
    <Dialog className={'fullScreenMobile'} open={open} onClose={onClose} scroll={'body'}>
      <DialogTitle>
        <TopHeader
          title={'Edit Role'}
          icon={<IShield size={20} />}
          onClose={_onClose}
        />
      </DialogTitle>
      <DialogContent>
        <AlertDialog
          open={openAlertOnEdit}
          loading={loading}
          description={
            'Editing role will force users with this role to refresh, are you sure you want to proceed?'
          }
          onClose={() => {
            setOpenAlertOnEdit(false);
          }}
          confirmBtn={<span style={{ color: 'green' }}>Confirm</span>}
          onConfirm={() => {
            setOpenAlertOnEdit(false);
            editRole();
          }}
        />
        <RoleForm
          onChange={(role) => {
            setRole(role);
          }}
          role={role}
        />
        <div
          style={{
            marginBottom: '20px',
            marginTop: '20px',
            textAlign: 'center',
          }}>
          <ActionBtn
            loading={loading}
            disabled={loading || (role && !role.name)}
            label={<span>Save Role</span>}
            onClick={_onSave}
            onEnter={_onSave}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}

EditRoleDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  editRole: PropTypes.func,
  role: PropTypes.object,
  onEdit: PropTypes.func,
};

EditRoleDialog.defaultProps = {
  open: false,
  onClose: () => {},
  role: {},
};

export default EditRoleDialog;
